<nb-card
  [ngClass]="{
    'table-minimized': isTableView(),
    'minimized': minimizedView,
    'extended': !minimizedView
  }"
  [ngStyle]="{
    'width': minimizedView && layoutService.widthByNb[sheetDialogNb]
      ? layoutService.widthByNb[sheetDialogNb]
      : layoutService.widthByNb[5]
  }"
>
  <nb-card-header [ngClass]="{
      'asset-color': assetId,
      'investment-color': investmentId,
      'initiative-color': initiativeId
    }"
    [ngStyle]="initiativesList || investmentsList
      ? { 'font-weight' : 'normal' }
      : {
          'font-weight' : 'normal',
          'height': '40px',
          'justify-content': 'center'
        }"
    [style.color]="initiativesList || investmentsList ? 'white' : '#222b45'"
    [style.height]="!minimizedView ? '60px' : '50px'"
  >
    <span>{{ title }}</span>
    <div class="button-groups">
      <button nbButton ghost status="primary" class="me-3" (click)="refresh()">
        <i class="fa-light fa-arrows-rotate-reverse"></i>
      </button>
      @if ((investmentId || assetId || (initiativeId && initiativeSiteId)) && canGoToAudit) {
        <button nbButton ghost status="primary" class="mobile-button me-3" (click)="goToAudit()">
          <fa-icon icon="mobile-notch" class="fat"></fa-icon>
        </button>
      }
      <button nbButton status="primary" (click)="close()">
        <i class="fa-light fa-x"></i>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body>
    @if (assetId) {
      <app-asset-sheet [assetId]="assetId" [minimizedView]="true"></app-asset-sheet>
    }
    @if (investmentId) {
      <app-investment-sheet [investmentId]="investmentId" [minimizedView]="true"></app-investment-sheet>
    }
    @if (initiativeId) {
      <app-initiative-sheet [initiativeId]="initiativeId" [minimizedView]="true"></app-initiative-sheet>
    }
    @if (initiativesList) {
      <app-initiatives-spreadsheet
        [inputFilters]="initiativesListFilters"
        [inputColumns]="initiativesListColumns"
        [inputScenario]="initiativesListScenario"
        [minimizedView]="true"
        [showScenarii]="showScenarii"
        [isFidjiAct]="isFidjiAct"
        >
      </app-initiatives-spreadsheet>
    }
    @if (investmentsList) {
      <app-investments-spreadsheet
        [currentScenario]="investmentsListScenario"
        [investmentsListColumns]="investmentsListColumns"
        [investmentsListFilter]="investmentsListFilter"
        [applyPeriod]="applyPeriod"
        [showAddButton]="false"
      ></app-investments-spreadsheet>
    }
    @if (assetsList) {
      <app-ag-grid-asset
        [level]="2"
        [assetsListFilter]="assetsListFilter"
        [style.color]="initiativesList || investmentsList ? 'white' : '#222b45'"
        [style.height]="!minimizedView ? '60px' : '50px'"
      >
        <span>{{ title }}</span>
        <div class="button-groups">
          @if((investmentId || assetId || (initiativeId && initiativeSiteId)) && canGoToAudit) {
            <button nbButton ghost status="primary" class="mobile-button me-3" (click)="goToAudit()">
              <fa-icon class="deeplink" [icon]='["fat", "pen-to-square"]'></fa-icon>
            </button>
          }
          <button nbButton status="primary" (click)="close()">
            <i class="fa-light fa-x"></i>
          </button>
        </div>
      </app-ag-grid-asset>
    }
  </nb-card-body>
</nb-card>
